import { useLocation } from "react-router-dom";
import { ESHOP_URL } from "@constants";

export const useNavigation = () => {
    const location = useLocation();

    const isRouteActive = (linkRoute: string) => {
        const currentPathname = location.pathname;

        if (ESHOP_URL && linkRoute.startsWith(ESHOP_URL)) {
            const routeWithoutEshop = linkRoute.replace(ESHOP_URL, "");

            return currentPathname === routeWithoutEshop || currentPathname.startsWith(routeWithoutEshop + "/");
        }

        return currentPathname === linkRoute || currentPathname.startsWith(linkRoute + "/");
    };

    return {
        isRouteActive,
    };
};
